import { Box, Typography, ButtonBase } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EVENT_LABELS } from '@tymely/features/Ticket/constants';

import CommentIdWithTooltip from './CommentIdWithTooltip';
import { IntentSuggestionHeaderProps } from '../types';
import { ExpandIconBox } from '../../styled';

const IntentSuggestionHeader = ({ kind, eventData, expanded, onToggle }: IntentSuggestionHeaderProps) => {
    const intentIds =
        eventData?.audit_log?.suggested_intents?.map((intent: { intent_id: number }) => intent.intent_id).join(', ') ||
        '';

    return (
        <ButtonBase
            onClick={onToggle}
            sx={{ width: '100%', textAlign: 'left', display: 'block', p: 0, borderRadius: 1 }}
            disableRipple
        >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ display: 'inline', mr: 1 }}>
                    {EVENT_LABELS[kind]}
                    {intentIds && ` - ${intentIds}`}
                </Typography>
                {eventData?.audit_log?.comment_id && (
                    <CommentIdWithTooltip commentId={eventData.audit_log.comment_id} />
                )}
                <ExpandIconBox>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ExpandIconBox>
            </Box>
        </ButtonBase>
    );
};

export default IntentSuggestionHeader;
